<!--handleClickLogin
 * @Author: pengyong
 * @Date: 2020-11-29 17:38:38
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-08 21:56:10
 * @LastEditors: awu
 * @LastEditTime: 2020-11-29 19:53:14
 * @Description: header登录注册按钮
 * @FilePath: /exhibit/src/components/LoginButton/index.vue
-->
<template>
    <div class="login-btn">
        <div class="cotentBox-userInfo" @click="handleClickLogin" v-if="!hideMenu">
            <!-- <img :src="require('@/assets/home/userinfo.png')" alt="" /> -->
            <span v-if="userInfo.id">
                <span v-if="userInfo.real_name">{{ userInfo.real_name }}</span>
                <span v-else>{{ $i18n.locale === 'zh' ? '个人中心' : 'PersonalCenter' }}</span>
            </span>
            <span v-else>
                {{ $t("exhibit").login }}
            </span>
        </div>
        <div class="actions" v-if="showCollpase" v-on-clickaway="handleClose">
            <div class="action" @click="handleNavigate">{{ $t("exhibit").user }}</div>
            <div class="action logout" @click="handleLogout">{{ $t("exhibit").exit }}</div>
        </div>
        <User v-if="showUserModal" @close="handleCloseUser" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import User from "@/views/user";
export default {
    components: {
        User
    },
    props: {
        hideMenu: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showCollpase: false
        };
    },
    computed: {
        ...mapState(["userInfo", "showUserModal"])
    },
    mounted() {
        // console.log(this.userInfo);
        this.$store.dispatch("getUserInfo");
    },
    methods: {
        handleClickLogin(e) {
            if (!this.userInfo.id) {
                this.$router.push("/role");
            } else {
                this.showCollpase = true;
            }
        },
        handleLogout() {
            this.$message.success("已退出登录")
            this.$store.commit("setLoginStatus", '')
            localStorage.setItem('isLogin', 0)
            localStorage.removeItem('access_token')

            setTimeout(()=>{
                this.handleClose();
                window.logout();
            },500)
        },
        handleClose() {
            this.showCollpase = false;
        },
        handleCloseUser() {
            this.$store.commit("setState", {
                showUserModal: false
            });
        },
        handleNavigate() {
            this.handleClose();
            if (!this.showUserModal) {
                this.$store.commit("setState", {
                    showUserModal: true
                });
            } else {
                this.$store.commit("setState", {
                    hideUserModalSideBar: false,
                    showChildId: 0
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.login-btn {
    padding-right: 60px;
    .cotentBox-userInfo {
        // margin-right: 30px;
        // width: 161px;
        // height: 45px;
        // background: #09468c;
        color: #49546B;
        display: flex;
        border-radius: 16px;
        // align-items: center;
        // justify-content: center;
        font-size: 18px;
        // color: #fff;
        cursor: pointer;
        > img {
            width: 16px;
            height: 20px;
            margin-right: 16px;
        }
    }
    @media screen and (max-width:1440px){
        .actions{
            bottom: 11px;
        }
    }
    @media screen and (min-width:1440px) and (max-width:1600px){
        .actions{
            bottom: 16px;
        }
    }
    @media screen and (min-width:1600px){
        .actions{
            bottom: 32px;
        }
    }
    .actions {
        position: absolute;
        // bottom: 32px;
        right: 4%;
        width: 130px;
        transform: translateY(100%);
        background: #ffffff;
        border-radius: 16px;
        overflow: hidden;
        padding: 0 10px;
        .action {
            text-align: center;
            color: #02448e;
            font-size: 13px;
            height: 45px;
            line-height: 45px;
            text-align: center;
            cursor: pointer;
        }
        .logout {
            color: #ea6767;
            border-top: 1px solid #09468c;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginButton/index.vue